import type { CountryResponse } from '@/types/country-timezone';

export const getCountriesAPI = () => {
	return useRequest<{data: CountryResponse[]}>(COUNTRIES_ENDPOINT, REQUEST_METHOD.GET);
};